export enum EVENT_ACTION_LOCAL {
    PERSONAL_PLAN = 'personal_plan',
}
